/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gross_Green_Canary_StopInputs */

const en_gross_green_canary_stop = /** @type {(inputs: Gross_Green_Canary_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users found`)
};

const de_gross_green_canary_stop = /** @type {(inputs: Gross_Green_Canary_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Benutzer gefunden`)
};

/**
* | output |
* | --- |
* | "No users found" |
*
* @param {Gross_Green_Canary_StopInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gross_green_canary_stop = /** @type {((inputs?: Gross_Green_Canary_StopInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gross_Green_Canary_StopInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gross_green_canary_stop(inputs)
	return de_gross_green_canary_stop(inputs)
});